// TODO: eliminat the switch statements in BlogLocal and loadPasts that require manual location name updating

import { writable } from 'svelte/store';
import { getPlacenames } from './location.api'; // Import your API function

// Define placenamesStore as an array of strings
const placenamesStore = writable<string[]>([]); // Specify the type as an array of strings

export const loadPlacenames = async (page = 0, pageSize = 100) => {
	try {
		// Add timeout protection to prevent blocking
		const placenamesPromise = getPlacenames(page, pageSize);
		const timeoutPromise = new Promise((_, reject) => {
			setTimeout(() => reject(new Error('Placenames query timeout')), 5000); // 5 second timeout
		});

		// Race between query and timeout
		const placenames: string[] = (await Promise.race([
			placenamesPromise,
			timeoutPromise
		])) as string[];

		placenamesStore.set(placenames);
	} catch (error) {
		console.error('Error loading placenames:', error);
		// Set empty array on error to prevent UI from breaking
		placenamesStore.set([]);
	}
};

export default placenamesStore;
